import { render } from "./AudioLibraryPicker.vue?vue&type=template&id=06e60d2c&scoped=true"
import script from "./AudioLibraryPicker.vue?vue&type=script&lang=ts"
export * from "./AudioLibraryPicker.vue?vue&type=script&lang=ts"

import "./AudioLibraryPicker.vue?vue&type=style&index=0&id=06e60d2c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-06e60d2c"

export default script